jQuery(document).ready(function($) {

	var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

	var homeSwiper = new Swiper('.home-slider .swiper-container', {
	    speed: 300,
	    loop: true,
		// autoplay: {
		// 	delay: 3000,
		// },
		navigation: {
			nextEl: '.next',
			prevEl: '.prev',
		},
	});	

    $('#c-client').on('change', function(event) {
        var v = $('#c-client option:selected').attr('data-v');
        $('.select-subject select').each(function(index, el) {
            if($(this).attr('id') == 'c-subject-' + v){
                $(this).removeClass('d-none')
            }else{
                $(this).addClass('d-none')
            }
        });
    });

	$('.select2').select2({
		minimumResultsForSearch: -1
	});

	$('.submit').on('click', function(event) {
		event.preventDefault();
		$(this).closest('form').submit();
	});

    $(".contact-form").validate({
    	lang: 'ro',
        errorPlacement: function (error, element) {
            if ($(element).attr("name") == 'client' || $(element).attr("name") == 'subject') {
                error.appendTo($(element).parent());
            } else {
                error.appendTo($(element).parent());
            }
        },
        submitHandler: function (form) {
            var data = {};

            data.name = $('#c-name').val();
            data.client = $('#c-client').val();
            data.email = $('#c-email').val();
            data.phone = $('#c-phone').val();
            data.subject = $('.select-subject select:not(.d-none)').val();
            data.message = $('#c-message').val();

            $(".contact-form .btn").addClass('disabled');

            $.ajax({
                url: window.location.origin + '/wp-content/themes/energoinstal/ajax/contact.php',
                type: 'POST',
                data: data,
            })
            .done(function() {
                
                $('.thank-you').removeClass('d-none');

            });               
        }
    });

    $('.menu-trigger').on('click', function(event) {
        event.preventDefault();
        $('body').toggleClass('menu-active');
    });

    $('header nav .menu li.menu-item-has-children').each(function(index, el) {
        var $this = $(this);
        $this.find('a').first().on('click', function(event) {
            event.preventDefault();
            $this.toggleClass('submenu-active');
        });
    });

    var stickyPostsSwiper = new Swiper('.sticky-posts .swiper-container', {
        speed: 400,
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        autoplay: {
            delay: 5000,
        },
    });

    var testimonialsSwiper = new Swiper('.testimonials .swiper-container', {
        speed: 400,
        spaceBetween: 0,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        autoplay: {
            delay: 5000,
        },
    });

    $('.members .view-all').on('click', function(event) {
        event.preventDefault();
        $('.members').addClass('active');
    });

    $('a[href^="#contact"]').on('click', function(event) {
        event.preventDefault();
        var hash = $(this).attr('href');
        var r = hash.split("_");

        if(r[1]){
            var v1 = $('#c-client option[data-v="'+ r[1] +'"]').val();
            $('#c-client').val(v1).trigger('change');
            $('#c-client').parent().addClass('active');
        }

        if(r[2]){
            var v = $('#c-client option:selected').attr('data-v');
            var v2 = $('#c-subject-' + v + ' option[data-v="'+ r[2] +'"]').val();
            $('#c-subject-' + v).val(v2).trigger('change');
            $('#c-subject-' + v).parent().addClass('active');
        }

        $('html, body').animate({
            scrollTop: $(r[0]).offset().top - 141
        }, 500);
    });

    $('.gallery-item').each(function(index, el) {
        var src = $(this).find('img').attr('src');
        $(this).attr('data-src', src);
    });

    $(".gallery").lightGallery({
        selector: '.gallery-item'
    }); 

    $('#nr_etaje, #nr_apartamente').on('keyup change', function(event) {
        calculeaza_costuri();
    });

    $('.calculate-costs').on('click', function(event) {
        event.preventDefault();
        calculeaza_costuri();
    });

    function calculeaza_costuri() {
        var nr_etaje = $("#nr_etaje").val();
        var nr_apartamente = $("#nr_apartamente").val();
        var rezultat=(445 + 445 + 499 + 790 + (nr_apartamente * 445)) / nr_apartamente;
        
        if(nr_etaje > 10) {
            var rezultat = (1349 + 1115 + (nr_apartamente * 445)) / nr_apartamente;
        };

        if(!isNaN(Math.round(rezultat*100)/100) && rezultat > 0){
            if(rezultat == Infinity){
                rezultat = 0;
            }
            $("#suma-totala").text(Math.round(rezultat*100)/100)
        }else{
            $("#suma-totala").text(0); 
        }

    }


    var delay = (function(){
      var timer = 0;
      return function(callback, ms){
        clearTimeout (timer);
        timer = setTimeout(callback, ms);
      };
    })();

    $(window).on('resize', function(event) {
        $('body').addClass('resize');
        delay(function(){
          $('body').removeClass('resize');
        }, 500);
    });

});